import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TimezoneProvider } from './contexts/TimezoneContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import NewAuditPage from './pages/NewAuditPage';
import ResultsPage from './pages/ResultsPage';
import HistoryPage from './pages/HistoryPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import HITLReviewPage from './pages/HITLReviewPage';
import AdminPage from './pages/AdminPage';
import StandardsLibraryPage from './pages/StandardsLibraryPage';
import ValidationProfilesPage from './pages/ValidationProfilesPage';
import BEPLibraryPage from './pages/BEPLibraryPage';
import PortfolioDashboardPage from './pages/PortfolioDashboardPage';
import AuditProgressPage from './pages/AuditProgressPage';
import RecentAIJobsPage from './pages/RecentAIJobsPage';
import BEPReadinessDashboardPage from './pages/BEPReadinessDashboardPage';
import LegalPage from './pages/LegalPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import AccountProfilePage from './pages/AccountProfilePage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <TimezoneProvider>
        <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          
          {/* Protected Routes */}
          <Route
            path="/account/profile"
            element={
              <ProtectedRoute>
                <AccountProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <NewAuditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/results/:auditId"
            element={
              <ProtectedRoute>
                <ResultsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audits/:auditId/progress"
            element={
              <ProtectedRoute>
                <AuditProgressPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/results"
            element={
              <ProtectedRoute>
                <ResultsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <HistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects"
            element={
              <ProtectedRoute>
                <ProjectsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/:projectId"
            element={
              <ProtectedRoute>
                <ProjectDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/:projectId/bep-readiness"
            element={
              <ProtectedRoute>
                <BEPReadinessDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hitl"
            element={
              <ProtectedRoute>
                <HITLReviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/standards"
            element={
              <ProtectedRoute>
                <StandardsLibraryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profiles"
            element={
              <ProtectedRoute>
                <ValidationProfilesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bep-library"
            element={
              <ProtectedRoute>
                <BEPLibraryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-jobs"
            element={
              <ProtectedRoute>
                <RecentAIJobsPage />
              </ProtectedRoute>
            }
          />
          
          {/* Default Redirect */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <PortfolioDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
        </BrowserRouter>
      </TimezoneProvider>
    </AuthProvider>
  );
}

export default App;